export default {
  protocol: {},
  history: [],
  protocolItems: [],
}
